import { Component, computed, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideLockKeyhole, lucideLockKeyholeOpen } from '@ng-icons/lucide';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { hlm } from '@spartan-ng/helm/utils';
import { cva } from 'class-variance-authority';
import { ClassValue } from 'clsx';

export const listVariants = cva('component-small-medium px-sm py-xs gap-xs flex w-fit items-center rounded-full', {
  variants: {
    variant: {
      estVerrouille: 'bg-feedback-warning-lightest text-feedback-warning-main',
      estDeverrouille: 'bg-feedback-informative-lightest text-feedback-informative-main',
    },
  },
});

@Component({
  selector: 'app-etat-verrouillage',
  imports: [HlmIconImports],
  templateUrl: './etat-verrouillage.component.html',
  providers: [provideIcons({ lucideLockKeyhole, lucideLockKeyholeOpen })],
})
export class EtatVerrouillageComponent {
  readonly estVerrouille = input.required<boolean>();

  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    hlm(
      listVariants({
        variant: this.estVerrouille() ? 'estVerrouille' : 'estDeverrouille',
      }),
      this.userClass(),
    ),
  );
  protected readonly label = computed(() => (this.estVerrouille() ? 'Verrouillé' : 'Déverrouillé'));
}
